import { IDialog } from './IDialog';
import { OnInit, ElementRef, Directive } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Directive()
export class DialogComponentContent implements IDialog{

    constructor(protected element: ElementRef, protected containerSelector: string = ".modal"){

    }

    ngOnInit(){
        $(this.element.nativeElement).find(this.containerSelector).delay(185).fadeIn(100);
    }

    close(dialogReference: MatDialogRef<any>, result = null){
        $(this.element.nativeElement).find(this.containerSelector).fadeOut(50);
        dialogReference.close(result);
    }
}